export default __webpack_public_path__ + "static/media/gold_card_selected.c32915a5.png";